export const importAll = function (ctx) {
  let cache = {};
  ctx.keys().forEach((key) => {
    cache = { ...cache, ...ctx(key) };
  });
  return cache;
};
